function initFileUploads(formWrapperEl) {
    const fileUploadWrappers = formWrapperEl.querySelectorAll('.ktc-file-component-wrapper');

    fileUploadWrappers.forEach((wrapperEl) => {
        const realUploadInput = wrapperEl.querySelector('.form-control');

        // CONTAINER
        const containerEl = document.createElement('div');
        containerEl.classList.add('file-upload');

        // BUTTON
        const buttonEl = document.createElement('button');
        buttonEl.classList.add('file-upload__button');
        buttonEl.setAttribute('type', 'button');
        buttonEl.addEventListener('click', () => realUploadInput.click());
        const labelEl = wrapperEl.querySelector('label:not(.control-label)'); // used the title instead of its text, since the text will be replaced by the file name (when the form re-renders), but the title remains the same
        const buttonText = labelEl ? labelEl.title : '';
        buttonEl.insertAdjacentHTML('beforeend', buttonText);

        // FIELD (with label and value)
        const fieldEl = document.createElement('div');
        fieldEl.classList.add('file-upload__field');
        const parentFormFieldEl = wrapperEl.parentElement.parentElement;
        const controlLabelEl = parentFormFieldEl.querySelector('.control-label');
        controlLabelEl.classList.add('file-upload__label');
        const valueEl = document.createElement('div');
        valueEl.classList.add('file-upload__value');
        fieldEl.appendChild(controlLabelEl);
        fieldEl.appendChild(valueEl);

        // COMPOSITION
        containerEl.appendChild(buttonEl);
        containerEl.appendChild(fieldEl);
        wrapperEl.appendChild(containerEl);

        function fillValueEl(fileName) {
            if (!fileName) {
                const el = wrapperEl.querySelector('.ktc-uploader-replacement')
                const fileNameWithTrailingWhiteSpace = el.innerText
                fileName = fileNameWithTrailingWhiteSpace.trim();
            }

            if (!fileName) {
                return;
            }

            const deleteButtonEl = document.createElement('button');
            deleteButtonEl.setAttribute('type', 'button');
            deleteButtonEl.classList.add('file-upload__delete-button');
            deleteButtonEl.addEventListener('click', () => clearValue());

            controlLabelEl.classList.add('file-upload__label--small');

            valueEl.innerText = fileName;
            valueEl.appendChild(deleteButtonEl);

            // todo: For some reason Kentico adds a disabled attribute to the '__RequestVerificationToken' input, while uploading a file to the server,
            // that is not removed when our code is executed.
            // So this is a quick fix to remove the disabled attribute ourselves,
            // because we don't understand why Kentico doesn't remove the disabled attribute.
            const requestValidationTokenInput = formWrapperEl.querySelector('[name="__RequestVerificationToken"]')
            if (requestValidationTokenInput) {
                requestValidationTokenInput.disabled = false
            }
        }

        function clearValue() {
            valueEl.innerText = '';
            controlLabelEl.classList.remove('file-upload__label--small');

            // Click on the actual Kentico Delete button to remove the file in the Kentico way, also on the server:
            const kenticoDeleteButton = wrapperEl.querySelector('.ktc-uploader-text-button');
            kenticoDeleteButton.click();
        }

        function handleUploadInputValue(e) {
            const {files} = e.target;
            const fileName = files[0] ? files[0].name : '';
            fillValueEl(fileName);
        }

        fillValueEl();
        realUploadInput.addEventListener('change', (e) => handleUploadInputValue(e));
    });
}

const kenticoFormWidgets = document.querySelectorAll('.kentico-form-widget-form');
kenticoFormWidgets.forEach((formWidget) => {
    const parentOfFormWidget = formWidget.parentElement;

    initFileUploads(parentOfFormWidget);

    /** When the form has errors, Kentico re-renders the complete form (no page reload), so the JavaScript for the file-uploads needs to be re-initialized: **/
    const kenticoFormWidgetObserver = new MutationObserver(() => {
        initFileUploads(parentOfFormWidget);
    });

    kenticoFormWidgetObserver.observe(parentOfFormWidget, {
        childList: true, // we only listen to the removal/adding of direct child nodes. So this is triggered on the re-render of the .kentico-form-widget-form div
    });
});
